export const FETCH_LIST = 'store/list';
export const FETCH_LIST_SUCCESS = 'store/list_success';
export const FETCH_LIST_FAILED = 'store/list_failed';

export const CLEAR_DATA = 'store/clear_data';

export type StoreAction = typeof FETCH_LIST | typeof FETCH_LIST_FAILED | typeof FETCH_LIST_SUCCESS | typeof CLEAR_DATA;
